import { useEffect } from "react";

import { OverlayOptions, overlayStore } from "@/Common/Stores/OverlayStore";

function useOverlay(key: string, options: OverlayOptions = null): void {
    useEffect(
        () => {
            overlayStore.showOverlay(key, options);

            return () => overlayStore.hideOverlay(key);
        },
        [key, options]
    );
}

export { useOverlay };
